export type BusinessSector =
  | 'Financial institution, remittance, currency exchange'
  | 'Public administration'
  | 'Hotel/Restaurant/Tourism/Rental services'
  | 'Marketing/Business development'
  | 'Transport/Logistic services'
  | 'Publishing'
  | 'Agriculture/Forestry'
  | 'Financial institution: Other'
  | 'Data/IT'
  | 'Construction/Infrastructure'
  | 'Law/Finance/Recruitment'
  | 'Real estate'
  | 'Religious community'
  | 'Investment-/Holding company'
  | 'Retail'
  | 'Healthcare'
  | 'Education/Communication'
  | 'Manufacture'
  | 'Charity/Fundraising'
  | 'Casino/Gaming industry'
  | 'Cryptocurrency business';

export type QbPayBusinessSector =
  | 'Retail & E-commerce'
  | 'Food Delivery & Hospitality'
  | 'Digital Goods & Subscriptions'
  | 'Software & SaaS Services'
  | 'Financial Services & FinTech'
  | 'Travel & Booking Services'
  | 'Health & Wellness'
  | 'Gaming & Entertainment'
  | 'Education & Online Courses'
  | 'Professional & Consulting Services'
  | 'Marketing & Advertising Services'
  | 'Non-Profit & Fundraising'
  | 'Crypto & Blockchain Services'
  | 'Other (please specify)';

export const BUSINESS_SECTORS: Record<BusinessSector, true> = {
  'Financial institution, remittance, currency exchange': true,
  'Public administration': true,
  'Hotel/Restaurant/Tourism/Rental services': true,
  'Marketing/Business development': true,
  'Transport/Logistic services': true,
  Publishing: true,
  'Agriculture/Forestry': true,
  'Financial institution: Other': true,
  'Data/IT': true,
  'Construction/Infrastructure': true,
  'Law/Finance/Recruitment': true,
  'Real estate': true,
  'Religious community': true,
  'Investment-/Holding company': true,
  Retail: true,
  Healthcare: true,
  'Education/Communication': true,
  Manufacture: true,
  'Charity/Fundraising': true,
  'Casino/Gaming industry': true,
  'Cryptocurrency business': true,
};
export const BUSINESS_SECTOR_OPTIONS = Object.keys(BUSINESS_SECTORS).map(
  (k) => ({ label: k, value: k })
);

export const QB_PAY_BUSINESS_SECTORS: Record<QbPayBusinessSector, true> = {
  'Retail & E-commerce': true,
  'Food Delivery & Hospitality': true,
  'Digital Goods & Subscriptions': true,
  'Software & SaaS Services': true,
  'Financial Services & FinTech': true,
  'Travel & Booking Services': true,
  'Health & Wellness': true,
  'Gaming & Entertainment': true,
  'Education & Online Courses': true,
  'Professional & Consulting Services': true,
  'Marketing & Advertising Services': true,
  'Non-Profit & Fundraising': true,
  'Crypto & Blockchain Services': true,
  'Other (please specify)': true,
};

export interface ContactInformation {
  postalRegion: string;
  postalNumber: string;
  country: string;
  address1: string;
}

export interface RelatedPersonBase {
  userReference?: string;
  firstName: string;
  lastName: string;
  isPep: boolean;
  dateOfBirth: Date | null;
  role: string | null;
  placeOfBirth: string | null;
  address: ContactInformation | null;
}

export interface RelatedPerson extends RelatedPersonBase {
  dateOfBirth: Date;
  type: string;
  ssn: string;
}

export interface RelatedPersonFormData extends RelatedPersonBase {
  type: string;
  ssn: string;
  address: ContactInformation;
}

export interface KybChange {
  changedBy: string;
  state: string;
  created: Date;
}
export interface KybBase {
  contactEmail: string | null;
  fullCompanyName: string;
  previousCompanyNames: string | null;
  registrationNumber: string;
  countryOfTaxResidence: string | null;
  taxIdentificationNumber: string | null;
  leiNumber: string | null;
  registeredAddress: ContactInformation;
  primaryAddress: ContactInformation | null;
  businessSectors: BusinessSector[];
  expectedMonthlyVolume: number;
  riskScoreAdjustment: number | null;
  usaConnection: boolean | null;
  kybApproved: boolean | null;
  businessOperations: string | null;
  reasonForUse: string | null;
  authorizedSignatory: string | null;
  licenseForBusiness: string | null;
  jurisdictions: string;
  turnover: number;
  expectedMonthlyTransactions: number;
}
export interface KybSave extends KybBase {
  id: string;
  incorporationDate: Date | null;
  onboardingDate: Date;
  incorporationCountry: string;
  relatedPeople: RelatedPerson[];
  settlementReportEmails: string[] | null;
}

export interface KybRead extends KybSave {
  changelog: KybChange[];
  // Null until the risk score has been calculated by the KYB screening
  riskScore: number | null;
}
export interface KybFormData extends KybBase {
  incorporationDate: Date | null;
  onboardingDate: Date | null;
  incorporationCountry: string | undefined;
  relatedPeople: RelatedPersonFormData[];
  riskScore: number | null;
  //Multiple emails will be comma separated
  settlementReportEmails: string | null;
  primaryAddress: ContactInformation;
}
